import Head from 'next/head'
import Hero from 'components/folds/succesverhalen-hero'
import BoxVertical from 'molecules/box-vertical'
import { Container } from 'react-bootstrap'
import { fetchAllPostsOfType, fetchPostIdsOfType } from 'lib/wp-fetcher';
import { cachedFetch } from 'lib/cached-fetch'

export default function Stories({
    stories,
}) {
    return (
        <div>
            <Head>
                <title>Fysiotherapie4all - Succesverhalen</title>
            </Head>
            <main>
                <Hero />
                
                <Container>
                    <div className="row justify-content-center">
                        {stories?.length > 0 && stories.map(result => {
                            return (
                                <div
                                    key={result.id}
                                    className={"col-xs-12 col-md-6 col-lg-4 text-center box-wrapper mb-4"}
                                >
                                    <BoxVertical
                                        imageSrc={result.featuredImage?.source_url}
                                        buttonType="tertiary"
                                        buttonLink={`/succesverhaal/${result.slug}`}
                                        Label="Lees verhaal"
                                    >
                                        <h3><div dangerouslySetInnerHTML={{__html: result.title.rendered}} /></h3>
                                    </BoxVertical>
                                </div>
                            );
                        })}

                        {stories?.length < 1 && 
                            <div className="row justify-content-center">
                                <h3 className="text-center">Geen resultaten gevonden</h3>
                            </div>
                        }
                    </div>
                </Container>
            </main>
        </div>
    );
}

export async function getStaticProps() {
    const fetchStories = await fetchAllPostsOfType('success')

    const stories = await Promise.all(fetchStories.map(async results => {
        if(results.featured_media) {
            results.featuredImage = await cachedFetch(`${process.env.NEXT_PUBLIC_API_URL}/wp-json/wp/v2/media/${results.featured_media}`)
        } else if(results.acf?.main_video) {
            const video = (await fetchPostIdsOfType(results.acf.main_video, 'videos'))[0];

            const url = new URL(video.acf?.url);

            if(url.host == 'vimeo.com') {
                results.featuredImage = { 'source_url': `https://vumbnail.com/${url.pathname}.jpg` }
            } else {
                let id = (video.acf?.url).replace('https://youtu.be/', '', video.acf?.url); 

                if(url.searchParams.get('v')) {
                    id = url.searchParams.get('v');
                }
            
                results.featuredImage = { 'source_url': `https://img.youtube.com/vi/${id}/mqdefault.jpg` }
            }
            
        }

        return results
    }))

    return {
        props: {
            stories,
        },
        revalidate: parseInt(process.env.REVALIDATION_TIME_SECONDS),
    }
}
